const universData = Object.freeze({
  ACQUISITION: "Acquisition",
  DATA_MARKTING: "DATA Marketing",
  ENGAGEMENT_CONVERSION: "Engagement & Conversion",
})

export default universData
